import React from 'react';
import { Link } from 'react-scroll';
import { FaSearch, FaMapMarkerAlt } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            Find Your <span>Dream Property</span> in Vasai West
          </h1>
          <p className="hero-subtitle">
            Trusted Real Estate Consultant Since 2016 | Rated 4.7/5 by Our Clients
          </p>

          <div className="hero-buttons">
            <Link to="properties" smooth={true} duration={500} offset={-70}>
              <button className="btn-primary">
                <FaSearch /> Browse Properties
              </button>
            </Link>
            <Link to="contact" smooth={true} duration={500} offset={-70}>
              <button className="btn-secondary">
                <FaMapMarkerAlt /> Schedule Visit
              </button>
            </Link>
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <h3>500+</h3>
              <p>Properties Sold</p>
            </div>
            <div className="stat-item">
              <h3>1000+</h3>
              <p>Happy Clients</p>
            </div>
            <div className="stat-item">
              <h3>8+</h3>
              <p>Years Experience</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;